/**
 * Install Prompt component for PWA installation
 */

import { Download, X } from 'lucide-react'
import { useInstallPrompt } from '@/hooks/useInstallPrompt'
import { Button } from '@/components/ui/button'

export function InstallPrompt() {
  const { isInstallable, isInstalled, promptInstall } = useInstallPrompt()

  if (!isInstallable || isInstalled) {
    return null
  }

  const handleInstall = async () => {
    await promptInstall()
  }

  const handleDismiss = () => {
    // Store dismissal in localStorage to avoid showing again for this session
    localStorage.setItem('pwa-install-dismissed', Date.now().toString())
  }

  // Check if user dismissed in this session
  const dismissed = localStorage.getItem('pwa-install-dismissed')
  if (dismissed) {
    const dismissedTime = parseInt(dismissed, 10)
    const oneDayAgo = Date.now() - 24 * 60 * 60 * 1000
    if (dismissedTime > oneDayAgo) {
      return null
    }
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-background border border-border rounded-lg shadow-lg p-4 z-50 animate-in slide-in-from-bottom-5">
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <h3 className="font-semibold text-sm mb-1">Cài đặt ứng dụng</h3>
          <p className="text-sm text-muted-foreground mb-3">
            Cài đặt Gold Tracker để truy cập nhanh hơn và sử dụng offline.
          </p>
          <div className="flex gap-2">
            <Button size="sm" onClick={handleInstall} className="flex items-center gap-2">
              <Download className="h-4 w-4" />
              Cài đặt
            </Button>
            <Button
              size="sm"
              variant="ghost"
              onClick={handleDismiss}
              className="flex items-center gap-2"
            >
              <X className="h-4 w-4" />
              Bỏ qua
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

